import { createAction, handleActions } from 'redux-actions';

const loadSubOrderStatuses = createAction("CORE/SUB_ORDER_STATUSES/LOAD_SUB_ORDER_STATUSES");
const clearSubOrderStatuses = createAction("CORE/SUB_ORDER_STATUSES/CLEAR_SUB_ORDER_STATUSES");

const defaultState = []

const reducer = handleActions(
  {
    [loadSubOrderStatuses]: (state, action) => action.payload,
    [clearSubOrderStatuses]: () => []
  },
  defaultState
);

export { loadSubOrderStatuses, clearSubOrderStatuses, reducer };
